export default __webpack_public_path__ + "static/media/bin-black.30349067.svg";